import React, { useState } from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { Select } from 'components/Form';
import { FileProperties, ScormResultSelect, ScormVersionSelect } from 'ui';
import coursesApiClient from 'utils/coursesApiClient';
import { Upload, Row, Col, Button, message, FormInstance, Form } from 'antd';
import Spinner from 'components/Spinner';

const formItemLayout = {
    labelCol: { span: 10 },
    wrapperCol: { span: 14 },
};
interface ScormFormInterface {
    language: string;
    handleVersionSelect: Function;
    versionList: any[];
    activityId: number;
    setMaterial: React.Dispatch<React.SetStateAction<any>>;
    reloadVersions: Function;
    form: FormInstance;
    versionsLoading: boolean;
    setFileTitle: React.Dispatch<React.SetStateAction<string>>;
    fileTitle: string;
    courseId: number;
    downloadFile?: () => void;
    displayBtn: boolean;
}

const ScormForm: React.FC<ScormFormInterface> = ({ language, handleVersionSelect, versionList, activityId, setMaterial, reloadVersions, form, versionsLoading, setFileTitle, fileTitle, courseId, displayBtn, downloadFile }) => {
    const [fileUpload, setFileUpload] = useState(false);
    const intl = useIntl();

    const uploadMaterial = async (file: any) => {
        setFileUpload(true);
        try {
            let bodyFormData = new FormData();

            if (file.file) {
                bodyFormData.append('file', file.file);
            } else {
                return;
            }

            bodyFormData.append('language', language);
            bodyFormData.append('type', 'SCORM_LEARNING');

            let response = await coursesApiClient.request(`/api/v1/courses/${courseId}/activities/${activityId}/material/add`, bodyFormData, 'POST');
            setFileTitle(response.material.settings.fileSettings.title);

            setMaterial(response.material.settings);

            const versions = await reloadVersions();

            const lastVersion: any = Object.values(versions).pop();

            form.setFieldsValue({
                version: lastVersion + ''
            });

        } catch (error) {
            console.error(error);
            message.error(intl.formatMessage({ id: 'error.data_load' }));
        } finally {
            setFileUpload(false);
        }
    }

    return (
        <Spinner spinning={fileUpload} opaqueH>
            <Form.Item label={<FormattedMessage id='courses.learning_file' />} {...formItemLayout}>
                <div className='upload-download-actions'>
                    <Upload
                        name='file'
                        multiple={false}
                        customRequest={(file: any) => uploadMaterial(file)}
                        fileList={[]}
                    >
                        <Button>
                            <i className="fa-solid fa-arrow-up-from-bracket"></i> <FormattedMessage id='general.upload_files' />
                        </Button>
                    </Upload>
                    {displayBtn && (
                        <Button
                            onClick={downloadFile}
                            icon={<i className="fa-solid fa-download"></i>}
                            disabled={!fileTitle}
                        >
                            <FormattedMessage id="general.download" />
                        </Button>
                    )}
                </div>
            </Form.Item>

            <FileProperties layout={formItemLayout} showSize={false} fileProperties={{
                title: fileTitle,
                titleLabel: 'courses.learning_file_title',
            }} />

            <ScormResultSelect layout={formItemLayout} name='expectedLearningResult' label='courses.expected_learning_result' customRules={[{ required: true, message: intl.formatMessage({ id: 'validation.field_required' }) }]} />
            <ScormVersionSelect layout={formItemLayout} name='learningFileScormVersion' label='courses.scorm_version' customRules={[{ required: true, message: intl.formatMessage({ id: 'validation.field_required' }) }]} />

            <Select
                loading={versionsLoading}
                customLayout={formItemLayout}
                label={intl.formatMessage({ id: "general.version" })}
                name='version'
                manualOptions={versionList}
                onChange={(_value: any, options: any) => handleVersionSelect(options.children, setFileTitle)}
            />

        </Spinner>
    )
}
export default ScormForm;
